import { useLocation } from 'react-router-dom';
import Theme404 from '../../layout/404';
import PagesEdit from './pages.edit';
import PagesList from './pages.list';

export default function Pages() {
  const { pathname } = useLocation();

  if (pathname === '/pages' || pathname === '/pages/') return <PagesList />;
  if (pathname === '/pages/new' || /^\/pages\/edit\/[^/]+\/?$/.test(pathname)) return <PagesEdit />;

  return <Theme404 />;
}
